import { render, staticRenderFns } from "./SelectionBasket.vue?vue&type=template&id=2035bc62&scoped=true"
import script from "./SelectionBasket.vue?vue&type=script&lang=js"
export * from "./SelectionBasket.vue?vue&type=script&lang=js"
import style0 from "./SelectionBasket.vue?vue&type=style&index=0&id=2035bc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035bc62",
  null
  
)

export default component.exports